import React, { Component } from "react";
import { WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Grid, Button } from "@material-ui/core";
import { styles } from "../../course/styling/WithNoContent";
import CreateCoursePopup from "./CreateCoursePopup/CreateCoursePopup";
import MyPATNoDataPanel from "../../common/MyPATNoDataPanel";

interface NoContentProps extends WithStyles<typeof styles> {
  createContentOpenHandler: Function;
  showCreateButton: boolean;
}

interface NoContentStates {
	openRequestPop:boolean,
}

class NoContent extends Component<NoContentProps, NoContentStates> {
  constructor(props: NoContentProps) {
    super(props);
	this.state={
		openRequestPop:false,
	}
  }
  
  handleCreateCourseBttn = () => {
	//add code
	this.setState({
	  openRequestPop:!this.state.openRequestPop
	})
   
  }
  render() {
    const { classes, createContentOpenHandler,showCreateButton } = this.props;
    const{openRequestPop}=this.state;
    return (
      <>
        {/* <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: "100vh" }}
        >
          <Grid item className={classes.center}>
            <img
              alt="no content"
              className={classes.img}
              src="/assets/img/course/no-content.png"
            />
            <Typography variant="h6" gutterBottom>
              Its so lonely here...
            </Typography>
            <Typography variant="caption" gutterBottom>
              No Courses have been shared with you yet. Get started by authoring
              your own course.
            </Typography>
            {
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleCreateCourseBttn.bind(this)}
              >
                Create Course
              </Button>
            }
            {openRequestPop && (
              <CreateCoursePopup
                open={openRequestPop}
                onClose={this.handleCreateCourseBttn}
              />
            )}
          </Grid>
        </Grid> */}
       <Grid style={{marginTop:160}}> 
        <MyPATNoDataPanel
              imageURL="/assets/svg/userManagement/noRollData.svg"
              heading=
              {
                <>
                {showCreateButton?
                 "No Course Created":"No Course Found"
                }
                </>
              }
              htmlElement={
                <>
                 {showCreateButton&&
                    <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleCreateCourseBttn.bind(this)}
                  >
                    Create Course
                  </Button>
                 } 
                  {openRequestPop && (
                    <CreateCoursePopup
                      open={openRequestPop}
                      onClose={this.handleCreateCourseBttn}
                    />
                  )}   
                </>
              }
              subPara={
                <>
                {showCreateButton?
              "You can create courses by clicking on the “Create Course” CTA below.":""
              }
              </>
              }

              />
           </Grid>   
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(NoContent);
